import { Button, ButtonProps } from 'antd';
import { FC } from 'react';
import './index.scss';

type Props = {
  text?: string;
  icon?: React.ReactElement | string;
  classname?: string;
} & ButtonProps;

export const CustomButton: FC<Props> = ({
  text,
  icon,
  type,
  className,
  ...props
}) => {
  return (
    <Button
      className={`custom-button ${type} ${className}`}
      type={type}
      {...props}
    >
      {icon && icon}
      {text && text}
    </Button>
  );
};
